import { GupStatisticsMemberLevelRsp } from '@/services/models/GupStatistics'
import { GupStatisticsService } from '@/services'

const gupStatistics = new GupStatisticsService()

export default {
  state: {
    memberLevel: [] as GupStatisticsMemberLevelRsp[]
  },

  getters: {
    memberLevel: (state: any) => state.memberLevel
  },

  mutations: {
    initialData(state: any) {
      state.memberLevel = [] as GupStatisticsMemberLevelRsp[]
    },
    setMemberLevelsList(state: any, memberLevel: GupStatisticsMemberLevelRsp[]) {
      state.memberLevel = memberLevel
    }
  },

  actions: {
    async getMemberLevelsList({ commit }: { commit: any }) {
      const resp = await gupStatistics.getMemberLevels()
      commit('setMemberLevelsList', resp.data)
    }
  },

  namespaced: true
}
